export default __webpack_public_path__ + "static/media/ero_dark_wordmark.40fd382d.svg";